import type { IconName, IconVariant } from '../../../design-system/icons/iconPaths';

export interface BenefitIconResult {
  name: IconName;
  variant: IconVariant;
}

/**
 * Gets the appropriate icon (cacheable SVG) for a benefit item based on keywords.
 */
export function getIconForBenefit(item: string): BenefitIconResult {
  const normalized = item.toLowerCase();
  const defaultIcon: BenefitIconResult = { name: 'briefcase', variant: 'outline' };

  if (['lunch', 'meal', 'food', 'dining', 'ruoka', 'lounas', 'måltid', 'mat', 'måltider'].some((kw) => normalized.includes(kw))) {
    return { name: 'briefcase', variant: 'outline' };
  }
  if (['health', 'insurance', 'medical', 'wellness', 'terveys', 'sairaus', 'vakuutus', 'sairausvakuutus', 'terveydenhuolto', 'hälsa', 'sjukförsäkring', 'sjukvård'].some((kw) => normalized.includes(kw))) {
    return { name: 'wifi', variant: 'outline' };
  }
  if (['phone', 'mobile', 'device', 'puhelin', 'mobiili', 'laite', 'telefon', 'mobil', 'enhet'].some((kw) => normalized.includes(kw))) {
    return { name: 'mapPin', variant: 'outline' };
  }
  if (['transport', 'commute', 'travel', 'matka', 'liikenne', 'kuljetus', 'pendelöinti', 'resor', 'resa'].some((kw) => normalized.includes(kw))) {
    return { name: 'arrowUpOnSquare', variant: 'outline' };
  }
  if (['sports', 'gym', 'fitness', 'exercise', 'urheilu', 'kuntosali', 'liikunta', 'sport', 'träning'].some((kw) => normalized.includes(kw))) {
    return { name: 'bookmark', variant: 'outline' };
  }
  if (['education', 'training', 'course', 'learning', 'koulutus', 'opiskelu', 'kurssi', 'utbildning', 'kurs', 'lärande'].some((kw) => normalized.includes(kw))) {
    return { name: 'bookmark', variant: 'solid' };
  }
  if (['bonus', 'reward', 'extra', 'bonukset', 'palkkio', 'lisä', 'belöning'].some((kw) => normalized.includes(kw))) {
    return { name: 'briefcase', variant: 'outline' };
  }
  if (['vacation', 'holiday', 'leave', 'lomapäivä', 'loma', 'vapaa', 'semester', 'ledighet', 'lov'].some((kw) => normalized.includes(kw))) {
    return { name: 'mapPin', variant: 'outline' };
  }
  if (['interview', 'meeting', 'haastattelu', 'tapaaminen', 'intervju', 'möte'].some((kw) => normalized.includes(kw))) {
    return { name: 'arrowUpOnSquare', variant: 'outline' };
  }
  if (['test', 'assessment', 'evaluation', 'koe', 'arviointi', 'testi', 'bedömning', 'prov'].some((kw) => normalized.includes(kw))) {
    return { name: 'wifi', variant: 'outline' };
  }
  if (['skill', 'competence', 'ability', 'taito', 'osaaminen', 'kompetenssi', 'färdighet', 'kompetens'].some((kw) => normalized.includes(kw))) {
    return { name: 'briefcase', variant: 'outline' };
  }
  return defaultIcon;
}
